import styled from "styled-components";
const bpDesktop = "900px";

export const Container = styled.div`
  position: fixed;
  z-index: 1000;
  background: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
  max-width: 550px;
  padding: 36px 24px;
  min-height: 40px;
  border-radius: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);

  @media (min-width: ${bpDesktop}) {
    padding: 40px;
  }

  input[type="text"] {
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  button:not(.close) {
    height: 40px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 20px;
    padding: 0 2rem;
    background: var(--color-pink);
  }
`;

export const Content = styled.div`
  /* //sdfsdf */
`;

export const Close = styled.button`
  width: auto;
  background: none;
  position: absolute;
  top: 1rem;
  right: 1rem;
  svg {
    stroke: #393939;
  }
`;
